import HeroContent from './HeroContent'

const Hero = () => {
  return (
    <HeroContent
      onScrollToForm={() => {
        document.getElementById('guest-invoice-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }}
    />
  )
}

export default Hero
